import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';

import { bindAll } from '@bibliocommons/utils-react';
import { checkoutsEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';

const { composeDownloadEvent } = checkoutsEventComposer;

export class DownloadCheckoutLink extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleDownloadLinkClick() {
    const { provider, bibId } = this.props;
    sendAnalyticsEvents(composeDownloadEvent({ provider }));
    if (typeof this.props.trackCheckoutConsumeDownload === 'function') {
      this.props.trackCheckoutConsumeDownload(bibId);
    }
  }

  render() {
    const { className } = this.props;

    return (
      <a
        href={this.props.downloadUrl}
        onClick={this.handleDownloadLinkClick}
        className={cn('cp-download-checkout-link', className)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage
          id={`download_now_${this.props.format.toLowerCase()}`}
          defaultMessage={this.props.intl.formatMessage(
            {
              id: 'download_now_format'
            },
            {
              format: this.props.intl.formatMessage({
                id: `digiformat_${this.props.format.toLowerCase()}`
              })
            }
          )}
        />
      </a>
    );
  }
}

DownloadCheckoutLink.propTypes = {
  className: PropTypes.string,
  provider: PropTypes.string,
  downloadUrl: PropTypes.string,
  format: PropTypes.string,
  bibId: PropTypes.string,
  trackCheckoutConsumeDownload: PropTypes.func
};

export default injectIntl(DownloadCheckoutLink);
